export const LangFr = {
    name: 'fr',
    data: {
        // Tab titles. Every route is served by the same index.html, so these are
        // applied at runtime from pages/layout.js.
        'pageTitles': {
            'loginTempWorker': "Connexion intérimaire — Jobbiz",
            'loginCompany': "Connexion entreprise — Jobbiz",
            'registerTempWorker': "Inscription intérimaire — Jobbiz",
            'forgot': "Mot de passe oublié — Jobbiz",
            'resetPassword': "Réinitialiser le mot de passe — Jobbiz",
            'invitation': "Invitation — Jobbiz",
            'finalizeAccount': "Finaliser mon compte — Jobbiz",
            'finalizeRegistration': "Finaliser mon inscription — Jobbiz",
            'privatePoolJoin': "Rejoindre un vivier — Jobbiz",
            'fallback': "Jobbiz - agence d'intérim digitale"
        },
        'privatePool': {
            'loading': "Chargement…",
            // French elision: "d'" before a vowel sound, "de" otherwise.
            'of': {
                'elided': "d'{company}",
                'plain': "de {company}"
            },
            'invalid': {
                'title': "Ce lien n'est plus valide",
                'text': "Demandez un nouveau lien à l'entreprise qui vous a invité."
            },
            'loadError': {
                'title': "Une erreur est survenue",
                'text': "La page n'a pas pu être chargée. Vérifiez votre connexion puis réessayez.",
                'retry': "Réessayer"
            },
            'form': {
                'invites': "vous invite dans son vivier",
                'title': "Rejoignez le vivier {ofCompany}",
                'intro': "Laissez vos coordonnées : l'entreprise pourra vous proposer ses missions. Jobbiz vous embauche en intérim et s'occupe du contrat et de la paie.",
                'firstname': "Prénom",
                'lastname': "Nom",
                'phone': "Numéro de téléphone",
                'email': "E-mail (facultatif)",
                'countryLabel': "Indicatif du pays",
                'phoneInvalid': "Numéro invalide",
                'emailInvalid': "Adresse e-mail invalide",
                'consent': "J'accepte d'être contacté par {company} et Jobbiz pour des missions.",
                'submit': "Rejoindre le vivier",
                'poweredBy': "Propulsé par Jobbiz",
                'errors': {
                    'invalidInput': "Certaines informations sont invalides. Vérifiez-les puis réessayez.",
                    'tooManyRequests': "Trop de tentatives. Réessayez dans quelques minutes.",
                    'generic': "Une erreur est survenue. Réessayez dans un instant."
                }
            },
            'countries': {
                'MQ': "Martinique",
                'GP': "Guadeloupe",
                'FR': "France"
            },
            'confirmation': {
                'title': "Vous êtes dans le vivier",
                'text': "{company} pourra vous inviter sur ses missions. Pour les recevoir, terminez votre inscription dans l'app Jobbiz : c'est là que vous signerez vos contrats.",
                'signUpWith': "Inscrivez-vous avec le {phone}",
                'phoneHint': "C'est grâce à ce numéro que l'app vous retrouvera dans le vivier {ofCompany}.",
                'download': "Télécharger l'app Jobbiz",
                'appStore': "App Store",
                'googlePlay': "Google Play"
            }
        },
        "sidebar": {
            'dashboard': 'Tableau de bord',
            "profil": "Mon profil",
            'search': 'Recherche de missions',
            'file': 'Mes documents',
            'mission': 'Mes missions',
            'help': 'Aide'
        },
        'profil': {
            'profil': 'Mon profil',
            'account': 'Mon compte',
            'knowledge': 'Mon savoir faire',
            'proof': 'Mes justificatifs',
            'availabilities': 'Mes disponibilités',
            'params': 'Paramètres'
        },
        'savoir': {
            "cv": 'Curriculum Vite',
            'exp': 'Expériences',
            'skills': 'Compétences',
            'lang': 'Languages',
            'tools': 'Matériels possédés'
        },
        'proof': {
            'identity': 'Justificatif d’identité',
            'degree': 'Formations',
            'licence': 'Permis'
        },
        'availabilities': {
            'myhours':'Mes horaires',
            'dispo':'Périodes d\'indisponibilité',
            'subtitleH':'Indiquez à quelles tranches horaires vous êtes disponible' +
                ' pour travailler.',
            'subtitleD':'Indiquez les périodes où vous n\'êtes pas du tout disponible.'

        },
        'justify':{
            'm_vitale_title_c':'Ajouter une carte vitale',
            'm_vitale_title_u':'Modifier la carte vitale',
            'm_vitale_title_d':'Supprimer une carte vitale',
            'm_vitale_d_content':'Êtes-vous sûr de vouloir supprimer votre carte' +
                ' vitale ? Cette action est irréversible.',
            'm_iban_title_c':'Ajouter une identité bancaire',
            'm_iban_title_u':'Modifier l\'identité bancaire',
            'm_iban_title_d':'Supprimer une identité bancaire',
            'm_identity_title_c':'Validation d’identité',
            'm_proof_title_c':'Ajouter un justificatif de domicile',
        }

    }
}